module.exports = __webpack_public_path__ + "media/images/Screen+Shot+2021-07-26+at+12.19 1-1587c13a358907cb1879fddb8be2dedb.png";